<div class="kr-countdown" :class="dynamicClasses"> <div class="kr-countdown-timer" :role="role" aria-atomic="true">{{ timer }}</div></div>